import { fetchOptions } from './csrf'

export interface LocalListingSetting {
  id: string | null
  enabled: boolean
  auto_post: boolean
  default_radius: number | null
  include_price: boolean
  include_photos: boolean
  created_at: string | null
  updated_at: string | null
}

interface LocalListingSettingResponse {
  local_listing_setting: LocalListingSetting
}

interface ErrorResponse {
  errors: string[]
}

export const localListingSettingsApi = {
  async show(): Promise<LocalListingSetting> {
    const response = await fetch('/api/v1/settings/local-listing', fetchOptions())
    if (!response.ok) throw new Error('Failed to load local listing settings')
    const data: LocalListingSettingResponse = await response.json()
    return data.local_listing_setting
  },

  async update(params: Partial<Omit<LocalListingSetting, 'id' | 'created_at' | 'updated_at'>>): Promise<LocalListingSetting> {
    const response = await fetch('/api/v1/settings/local-listing', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ local_listing_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: LocalListingSettingResponse = await response.json()
    return data.local_listing_setting
  },
}
